<template>
  <div class="searchComp">
    <div class="container">
      <el-row :gutter="25" type="flex" justify="center" style="margin-right:0">
        <el-col :span="5">
          <div class="logo" >
            <LableSearch v-if="showLabel" />
            <a v-else href="/">
              <el-image
                style="width: 180px;"
                :src="carouselItems"
                lazy
              ></el-image>
            </a>
          </div>
        </el-col>
        <el-col :span="14" align="middle">
          <el-autocomplete
            @keyup.enter.native="search"
            style="width:645px;margin-left: -20px"
            v-model="searchData"
            size="large"
            class="search"
            placeholder="输入你想查找的商品"
            :trigger-on-focus="false"
            :debounce="1000"
            :fetch-suggestions="getNameList"
            @select="handleSelect"
            :popper-append-to-body="false"
          >
            <template slot="append">
              <el-button icon="el-icon-search" @click="search" style="font-size:16px">搜索</el-button>
            </template>
          </el-autocomplete>
        </el-col>
        <el-col :span="2">
           <div class="quick-quote" @click="toFastPrice">
             <!-- <div class="search-money">
               <img src="../../../static/img/icon/search-money.png" alt="">
             </div> -->
             <i class="iconfont icon-huozhuduanxunbaojia" style="font-size:18px;margin-top:1px"></i>
             <div style="margin-left:5px">批量下单</div>
           </div>
        </el-col>
        <el-col :span="3" style="padding-left:20px">
          <div
            class="shopping-car-button"
            @mouseenter="mouseenter"
            @mouseleave="mouseLeave"
            @click.stop="toShoppingCart"
          >
            <span>
              <i class="el-icon-shopping-cart-2 shopping-cart" style="font-size:18px"></i>
              <span style="color:#ffffff;font-size:16px">购物车</span>
            </span>
            <span v-if="num" class="shopping-car-number">{{ num }}</span>
            <div class="empty" v-show="show"></div>
            <div
              class="shoppingCart"
              v-show="show"
              :duration="{ enter: 100, leave: 100 }"
              @mouseenter="mouseenter"
              @mouseleave="mouseLeave"
            >
              <div class="list" v-if="list.length != 0">
                <div class="item" v-for="(item, index) in list" :key="index">
                  <div class="left">
                    <div class="img">
                      <img :src="item.skuImage" alt="" />
                    </div>
                    <div class="desc">{{ item.productSkuName }}</div>
                  </div>
                  <div class="right">
                    <div class="price">
                      <span>{{ $fix.fixed(Number(item.salesPrice)) }}</span>
                      x{{ item.orderAmount }}
                    </div>
                    <div class="btn btn_del" @click.stop="del(item)">删除</div>
                  </div>
                </div>
              </div>
              <div class="footer" v-if="list.length != 0">
                <div class="sum">
                  <div class="txt">
                    合计：<span>￥{{ numberToCurrencyNo(total) }}</span
                    >元
                  </div>
                  <div class="btn">去购物车结算</div>
                </div>
              </div>
              <div class="none" v-else>
                购物车空空如也~
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import store from "@/vuex/store";
import { searchShoppingCartProductNoCartProduct, delShoppingCart } from "@/api/order";
import { numberToCurrencyNo } from "../../utils/utils"
import {getProductName} from "../../api/search"
import LableSearch from './lableSearch.vue'
import {getHomeBannerByType} from '@/api/user'
export default {
  name: "Search",
  components: { LableSearch },
  data() {
    return {
      searchData: "",
      promotionTags: [
        "买2免1",
        "领200神券",
        "199减100",
        "母婴5折抢",
        "充100送20"
      ],
      show: false,
      showTest: false,
      numberToCurrencyNo,
      nameList: [],
      logoimg:"",
      showLabel:false
    }
  },
  props: {
    searchText: {
      type: String,
      default: ""
    }
  },
  computed: {
    list() {
      return store.state.shoppingCart;
    },
    num() {
      return store.state.shoppingCart.length;
    },
    total() {
      return store.state.totalPrice;
    },
    carouselItems() {
      let carouselItems = store.state.HomeBanner.find(item => item.type === 8);
      return carouselItems&&carouselItems.list &&carouselItems.list[0]?carouselItems.list[0].imageUrl:""
    },
  },
  created() {
    // console.log(process.env.NODE_ENV);
    if (process.env.NODE_ENV == "test") {
      this.showTest = true;
    }
    setTimeout(() => {
      this.searchData = this.searchText === "" ? "" : this.searchText;
    }, 500);
    this.searchShoppingCart();
    this.$watch(
      () => this.$route.params,()=>{
        this.showLabel=['/GoodsList','/activityZone','/goCompany','/goodDetail','/shoppingGuide','/'].includes(this.$route.path)
      })
  },
  mounted() {
    // getHomeBannerByType(8).then(res=>{
    //     if (res.data.code === 200) {
    //       let carouselItems = res.data.data;
    //       this.logoimg=carouselItems[0].imageUrl
    //     }
    // })
  },
  methods: {
    searchShoppingCart() {
      if (localStorage.getItem("loginUserInfo")) {
        searchShoppingCartProductNoCartProduct("").then(res => {
        if (res.data.code == 200) {
          res.data.data.forEach(item => {
            // let idx = item.orderUnits.findIndex(v => v.orderUnit === item.chargeUnit)
            // if(item.orderUnits && item.orderUnits.length > 0) {
            //   if( item.orderAmount === item.minOrderQuantity) {
            //     if(item.productAttribute === 2) {
            //       if(item.orderUnits[idx].rate ===1) {
            //         if (item.minOrderQuantity / item.chargeQty > Math.floor(item.minOrderQuantity / item.chargeQty)) {
            //           let a = (Math.floor(item.minOrderQuantity / item.chargeQty) + 1) * item.chargeQty
            //           this.$set(item,'orderAmount',a)
            //         } else {
            //           let a = (Math.floor(item.minOrderQuantity / item.chargeQty)) * item.chargeQty
            //           this.$set(item,'orderAmount',a)
            //         }
            //       }
            //     } else {
            //         if (item.minOrderQuantity / item.chargeQty > Math.floor(item.minOrderQuantity / item.orderUnits[idx].rate)) {
            //           let a = Math.floor(item.minOrderQuantity /  item.orderUnits[idx].rate) + 1
            //           this.$set(item,'orderAmount',a)
            //         } else {
            //           let a = Math.floor(item.minOrderQuantity / item.orderUnits[idx].rate)
            //           this.$set(item,'orderAmount',a)
            //         }
            //         let a = (Math.floor(item.minOrderQuantity / item.chargeQty) + 1) * Math.floor(item.chargeQty / item.orderUnits[index].rate)
            //         this.$set(item,'orderAmount',a)
            //     }
            //   }
            // }
          });
          store.commit("SET_SHOPPING_CART", res.data.data.filter((i) => !i.custPackId));//过滤掉包装
        }
      });
    }
    },
    closeTags(index) {
      this.promotionTags.splice(index, 1);
    },
    selectTags(index) {
      this.searchData = this.promotionTags[index];
    },
    search() {
      if (!this.searchData) {
        if (this.$route.path !== "/GoodsList") {
          this.$router.push({
            path: "/GoodsList",
            query: { searchData: this.searchData, type: "2" }
          });
        } else {
          this.$emit("refresh", this.searchData);
          this.$router.replace({
            path: "/GoodsList",
            query: { searchData: this.searchData, type: "2" }
          });
        }
      } else {
        // this.$router.replace({
        //   path: "/GoodsList",
        //   query: { searchData: this.searchData, type: "2" }
        // });
        if(this.$route.name==="Home"){
          this.$router.push({
            path: "/GoodsList",
            query: { searchData: this.searchData, type: "2" }
          })
          return
        }
        let routeData = this.$router.resolve({
          path: "/GoodsList",
          query: { searchData: this.searchData, type: "2" }
        });
        window.open(routeData.href, "_blank");
      }
    },
    mouseenter() {
      this.show = true;
    },
    mouseLeave() {
      this.show = false;
    },
    del(item) {
      let data = {
        cartId: item.cartId
      };
      delShoppingCart(data).then(res => {
        if (res.data.code == 200) {
          store.commit("DEL_SHOPPING_CART", item);
        }
      });
    },
    toShoppingCart() {
      if (localStorage.getItem("loginUserInfo")) {
        this.$router.push("/shoppingCart");
      } else {
        store.commit("SHOW_LOGIN_BOX");
      }
    },
    async getNameList(queryString, cb) {
      let _that = this
      await getProductName(queryString).then(res => {
        _that.nameList = []
        if (res.data.code === 200) {
          let objs = res.data.data
          objs.map(obj => _that.nameList.push({value: obj}))
        }
        cb(_that.nameList)
        _that.searchData = queryString

      })
    },
    handleSelect(item) {
      this.searchData = item.value;
    },
    toFastPrice() {
      if(!localStorage.getItem("loginUserInfo")) {
        this.$router.push({path: '/loginAndRegister', query: {type: 2}})
      } else {
        this.$router.push('/batchOrder')
      }

    }
  }
};
</script>

<style scoped lang="scss">
@import "../../styles/variables.scss";
/deep/ .search .el-input-group__append {
  background-color: $mainYellowColor;
  color: #fff;
  border-color: $mainYellowColor;
}
/deep/ .search .el-input__inner {
  border-color: $mainYellowColor;
}

/deep/ .search .el-input__inner:focus {
  border-color: $mainYellowColor;
}

/deep/ .search li {
  font-size: 12px;
  line-height: 25px;
  display:flex;
  color: #606266;
}
/deep/ .el-icon-search {
  font-size: 18px;
}

.searchComp {
  width: 1152px;
  margin: 0 auto;
  padding: 0 34px;
  padding-right: 0;
}
.shopping-cart {
  font-size: 16px;
  color: #FFFFFF;
  font-weight: 700;
}

.container {
  padding-top: 20px;
  // padding-bottom: 10px;
  position: relative;
  // width: 900px;
}
.search {
  // margin: 5px 0px;
  margin-bottom: 10px;
}
/deep/ .el-icon-search {
  margin-right: 5px;
}
.logo {
  width: 146px;
  height: 118px;
}

.shopping-car-button {
  // margin-left: 10px;
  width: 118px;
  background: $mainYellowColor;
  border: 1px solid $mainYellowColor;
  border-radius: 5px;
  height: 38px;
  // box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 17px;
  position: relative;
  .empty {
    position: absolute;
    background: white;
    top: 33px;
    right: 0;
    width: 100%;
    height: 5px;
    z-index: 200;
  }
  .shoppingCart {
    padding-top: 10px;
    position: absolute;
    background: white;
    top: 38px;
    right: 0;
    width: 500px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
    z-index: 200;
    .list {
      padding: 0 20px;
      max-height: 350px;
      overflow-y: scroll;
      color: #666;
      cursor: auto;
      .item:hover {
        background: #ebecee;
      }
      .item {
        padding: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .left {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          flex: 2;
          .img {
            width: 50px;
            height: 50px;
            margin-right: 6px;
            img {
              width: 100%;
              height: 100%;
              margin: 0;
              padding: 0;
            }
          }
          .desc {
            font-size: 12px;
            cursor: pointer;
          }
          .desc:hover {
            color: $hoverTxtColor;
          }
        }
        .right {
          margin-left: 20px;
          text-align: right;
          min-width: 90px;
          font-size: 12px;
          display: flex;
          justify-content: end;
          flex: 1;
          .price {
            span {
              color: $hoverTxtColor;
              font-weight: bold;
            }
          }
          .btn_del{
            width: 32px;
          }
          .btn {
            cursor: pointer;
            margin-left: 6px;
          }
          .btn:hover {
            color: $hoverTxtColor;
          }
        }
      }
    }
    .footer {
      width: 90%;
      margin: 0 auto;
      border-top: 1px dotted #bfbfbf;
      padding: 20px 20px;
      .sum {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        font-size: 12px;
        .txt {
          span {
            color: $hoverTxtColor;
          }
        }
        .btn {
          background: $mainYellowColor;
          line-height: 26px;
          border-radius: 3px;
          color: white;
          font-weight: bold;
          margin-left: 5px;
          padding: 0 10px;
        }
      }
    }
    .none {
      line-height: 50px;
      text-align: center;
      padding-bottom: 10px;
      color: #666;
    }
  }
}

.shopping-car-button a {
  color: #666;
}

.shopping-car-button a:hover {
  color: $mainYellowColor;
}

.shopping-car-number {
  position: absolute;
  top: 5px;
  right: 3px;
  width: 23px;
  height: 16px;
  line-height: 16px;
  background: #FFFFFF;
  border-radius: 7px 7px 7px 0;
  font-size: 12px;
  font-weight: 400;
  color: $mainYellowColor;
  text-align: center;
  text-indent: 0;
}

.quick-quote {
  height: 38px;
  margin-left: -10px;
  width: 100px;
  background: #ffffff;
  border: 1px solid #FF8E31;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #FF8E31;
  font-size: 14px;
  cursor: pointer;
  // margin-left: 10px;
  .search-money {
    width: 20px;
    height: 21px;
    margin-right: 10px;
    img {
      width: 20px;
      height: 21px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/search/Search.vue